// Lightweight global unauthorized event bridge between non-React services and AuthContext.
// Services (e.g., ApiService) can call triggerUnauthorized() on 401 responses.
// AuthProvider registers a handler so we can safely update React state & navigate.

type UnauthorizedHandler = () => void;

let unauthorizedHandler: UnauthorizedHandler | null = null;

export function registerUnauthorizedHandler(handler: UnauthorizedHandler): void {
  unauthorizedHandler = handler;
}

export function triggerUnauthorized(): void {
  try {
    unauthorizedHandler?.();
  } catch {
    // Silently ignore to avoid cascading failures inside fetch chain.
  }
}
